export default __webpack_public_path__ + "3fa1005a04a014753c61cccd41d368fa.png";